import { ActionTree } from "vuex";
import { CallingState } from "./state";
import { MainRoles, RemoteTeachingService } from "@/services";
import { CallingDeviceType } from "@/agora";
import { TeacherRoomManager } from "@/manager/room/teacher.manager";
import { StudentRoomManager } from "@/manager/room/student.manager";
import { defineVuexName, vuexName, MODULES } from "@/store/utils";

export interface PostLocalUserReconnectedPayload {
  localUserRole: MainRoles;
  localUserId: string;
}

const POST_LOCAL_USER_RECONNECTED_INTERVAL_MS = 60_000;

const actions: ActionTree<CallingState, any> = {
  //callingUpdateDevice
  async [defineVuexName(MODULES.CALLING.DISPATCHES.CALLING_UPDATE_DEVICES)](
    { dispatch, rootState },
    options: { deviceType: CallingDeviceType; isTurnOff?: boolean },
  ) {
    const module = rootState.teacherRoom.teacher ? "teacherRoom" : "studentRoom";
    let act = "updateCameraDevice";
    if (options.deviceType === CallingDeviceType.MICROPHONE) {
      act = "updateMicrophoneDevice";
    } else if (options.deviceType === CallingDeviceType.SPEAKER) {
      act = "updateSpeakerDevice";
    }
    const payload = options.deviceType === CallingDeviceType.CAMERA && options.isTurnOff ? { blockReopen: true } : {};
    await dispatch(`${module}/${act}`, payload, { root: true });
  },
  //reRegisterHotPluggingDevicesEventListener
  [defineVuexName(MODULES.CALLING.DISPATCHES.RE_REGISTER_HOT_PLUGGING_DEVICES_EVENT_LISTENER)]({ rootState }) {
    const manager: TeacherRoomManager | StudentRoomManager | undefined = rootState.teacherRoom.teacher
      ? rootState.teacherRoom?.manager
      : rootState.studentRoom?.manager;
    manager?.agoraClient?.registerHotPluggingDevicesEventListener();
  },
  // Every upon 1 minute, we will call this API to inform the server that the local user (especially TEACHER) is still online, to ensure the class never ends
  //postLocalUserReconnected
  async [defineVuexName(MODULES.CALLING.DISPATCHES.POST_LOCAL_USER_RECONNECTED)](
    { getters, commit, rootGetters },
    payload: PostLocalUserReconnectedPayload,
  ) {
    const sessionId = rootGetters[vuexName(MODULES.CLASS_TEACHING.GETTERS.GET_SESSION_ID)];
    const { localUserRole, localUserId } = payload;
    const triggerApi = async () => {
      await RemoteTeachingService.postLocalUserReconnected({
        localUserRole,
        localUserId,
        sessionId,
      });
    };
    await triggerApi();
    const postLocalUserReconnectedIntervalId = getters[vuexName(MODULES.CALLING.GETTERS.GET_POSTLOCAL_USER_RECONNECTED_INTERVAL_ID, false)];
    if (postLocalUserReconnectedIntervalId) clearInterval(postLocalUserReconnectedIntervalId);
    const intervalId = setInterval(async () => {
      await triggerApi();
    }, POST_LOCAL_USER_RECONNECTED_INTERVAL_MS);
    commit(vuexName(MODULES.CALLING.COMMITS.SET_POSTLOCAL_USER_RECONNECTED_INTERVAL_ID, false), intervalId);
  },
};

export default actions;
